import { CanDeactivateFn } from '@angular/router';

/** A page that can ask before the router takes the user away. */
export interface LeaveCheck {
  canLeave(): boolean | Promise<boolean>;
}

/**
 * Asks before leaving Smart broadcast with unsent work. The page decides:
 * it lets the user go straight away when nothing is at stake (no sheet,
 * already sent) and otherwise shows its own Stay / Leave dialog.
 *
 * Wire it on the route: `canDeactivate: [smartBroadcastLeaveGuard]`.
 */
export const smartBroadcastLeaveGuard: CanDeactivateFn<LeaveCheck> = (component) =>
  component && typeof component.canLeave === 'function' ? component.canLeave() : true;
